// extracted by mini-css-extract-plugin
export var ModalContainer = "ImageModal-module--ModalContainer--T0qJv";
export var DarkBackground = "ImageModal-module--DarkBackground--dr0qR";
export var ModalOne = "ImageModal-module--ModalOne--vQ6cv";
export var ImgContainer = "ImageModal-module--ImgContainer--7y3WH";
export var ModalMoreButton = "ImageModal-module--ModalMoreButton--w7m0m";
export var ModalExitButton = "ImageModal-module--ModalExitButton--u2B7V";
export var ModalExitButtonInvert = "ImageModal-module--ModalExitButtonInvert--0pjNB";